/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropwinnersattachremove3Inputs */

const en_dropwinnersattachremove3 = /** @type {(inputs: Dropwinnersattachremove3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove file`)
};

const de_dropwinnersattachremove3 = /** @type {(inputs: Dropwinnersattachremove3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei entfernen`)
};

/**
* | output |
* | --- |
* | "Remove file" |
*
* @param {Dropwinnersattachremove3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnersattachremove3 = /** @type {((inputs?: Dropwinnersattachremove3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnersattachremove3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnersattachremove3(inputs)
	return de_dropwinnersattachremove3(inputs)
});
export { dropwinnersattachremove3 as "dropWinnersAttachRemove" }